import { DictionaryAutocomplete, useStaticListSource } from '@eas/common-web';
import { ResearchQueryType } from '@enums';

export function useResearchQueryType() {
  return useStaticListSource<DictionaryAutocomplete>([
    { id: ResearchQueryType.PERIOD_QUERY, name: 'Periodická rešerše' },
    { id: ResearchQueryType.QUERY, name: 'Uživatelský dotaz' },
    { id: ResearchQueryType.TEXT_ANALYSIS, name: 'Textová analýza' },
  ]);
}
